<template>
  <div>
    <a-tabs defaultActiveKey="1">
      <a-tab-pane tab="REGISTRO DE VIATICOS" key="1">
        <g-master name="wfrequestmaster"
                  :endpoint="vMaster.endpoint"
                  :tableSetup="vMaster.tableSetup"
                  :modalFieldsSetup="vMaster.modalFieldsSetup"
                  @action="vMasterAction"
                  :actions="vMaster.actions"
                  :useMultipart="true"
                  :parentData="filtroMisViaticos"
                  :beforeSend="vMaster.beforeSend"
                  ref="masterComponent"
        >
          <template slot="masterModal" slot-scope="{record}">
            <g-lookup label="Empleado"
                      :formItemConfig="fiOptions"
                      endpoint="empleados"
                      :decorator="['id_emp', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                      :selectedObj.sync="vMaster.empleadoSeleccionado"
                      ref="empDropDown"
                      v-if="isRolViaticos">
            </g-lookup>
            <a-form-item label="Fecha" v-bind="fiOptions">
              <a-date-picker style="width: 100%"
                             v-decorator="['start_date', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
            </a-form-item>

            <g-dropdown endpoint="viaticos/locations"
                        :decorator="['id_loc_origin', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                        label="Origen"
                        :cache="false"
                        :formItemConfig="fiOptions"/>

            <g-dropdown endpoint="viaticos/locations"
                        :decorator="['id_loc_destination', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                        label="Destino"
                        :cache="false"
                        :formItemConfig="fiOptions"/>

            <a-form-item label="Hora Inicio" v-bind="fiOptions">
              <a-time-picker :minuteStep="15" use12Hours format="h:mm a"
                             v-decorator="['start_time', {type:'object', rules: [{ required: true, message: 'Valor requerido' }] }]"
                             placeholder="Hora Inicio"
                             style="width: 100%"></a-time-picker>
            </a-form-item>
            <a-form-item label="Hora Fin" v-bind="fiOptions">
              <a-time-picker :minuteStep="15" use12Hours format="h:mm a"
                             v-decorator="['end_time', {type:'object', rules: [{ required: true, message: 'Valor requerido' }] }]"
                             placeholder="Hora Fin"
                             style="width: 100%"></a-time-picker>
            </a-form-item>
            <a-form-item :hasFeedback="false" v-bind="fiOptions" :label="$t('Tipo de operación')">
              <a-radio-group
                @change="changeTipoOperacion"
                v-decorator="['type_operation', { rules: [{ required: true, message: 'Valor requerido' }] }]">
                <a-row>
                  <a-col span="24">
                    <a-radio :value="true">
                      Kilometraje y transporte
                    </a-radio>
                  </a-col>
                  <a-col span="24">
                    <a-radio :value="false">
                      Viaticos
                    </a-radio>
                  </a-col>
                </a-row>
              </a-radio-group>
            </a-form-item>
            <a-form-item v-show="esViatico" v-bind="fiOptions" :label="$t('Tipo de viatico')">
              <a-radio-group v-model="tipoViaticoSeleccionado">
                <a-row>
                  <a-col span="24">
                    <a-radio value="simple_expenses">
                      Viaticos Sencillo
                    </a-radio>
                  </a-col>
                  <a-col span="24">
                    <a-radio value="overnight_expenses">
                      Viaticos Pernoctado
                    </a-radio>
                  </a-col>
                  <a-col span="24">
                    <a-radio value="replacement_simple_expenses">
                      Viaticos con sueldo de reemplazo
                    </a-radio>
                  </a-col>
                  <a-col span="24">
                    <a-radio value="replacement_overnight_expenses">
                      Viaticos con sueldo de reemplazo pernoctado
                    </a-radio>
                  </a-col>
                </a-row>
              </a-radio-group>
            </a-form-item>
            <a-form-item :hasFeedback="false" v-show="eskilometrajeTransporte" v-bind="fiOptions" :label="$t('Viaje')">
              <a-radio-group
                v-decorator="['type_travel', { rules: [{ required: false, message: 'Valor requerido' }] }]">
                <a-row>
                  <a-col span="24">
                    <a-radio :value="false">
                      Solo ida
                    </a-radio>
                  </a-col>
                  <a-col span="24">
                    <a-radio :value="true">
                      Ida y vuelta
                    </a-radio>
                  </a-col>
                </a-row>
              </a-radio-group>
            </a-form-item>
            <a-form-item v-bind="fiOptions" :label="$t('Tipo de visita')">
              <a-radio-group v-model="tipoVisitaSeleccionado">
                <a-row>
                  <a-col span="24">
                    <a-radio value="extra_distance_1">
                      Visita Bocatoma
                    </a-radio>
                  </a-col>
                  <a-col span="24">
                    <a-radio value="extra_distance_2">
                      Visita Planta
                    </a-radio>
                  </a-col>
                </a-row>
              </a-radio-group>
            </a-form-item>
            <g-dropdown endpoint="person_vehicle"
                        :decorator="['id_person_vehicle']"
                        label="Vehiculo"
                        v-if="userHasVehicle"
                        :formItemConfig="fiOptions"
                        :params="vehicleParams"/>
            <a-upload
              name="attachment_file"
              :before-upload="file => beforeUpload(file, 'vMaster','attachment_file')"
              :remove="file => removeFile(file, 'vMaster','attachment_file')"
              :fileList="vMaster.uploads.attachment_file ? [vMaster.uploads.attachment_file]: []">
              <a-button style="width: 100%">Seleccionar Adjunto</a-button>
            </a-upload>
          </template>
          <div slot="kmRender" slot-scope="{text}" style="text-align: right;">
            {{parseInt(text) / 1000}} KM
          </div>
          <span slot="stateRender" slot-scope="{text}">

            <a-tag :color="getColorState(text)"> {{text}} </a-tag>
          </span>
        </g-master>
        <a-tabs defaultActiveKey="1" v-if="this.$userIsInrol('ViaticosJefe')">
          <a-tab-pane tab="REGISTRO DE VIATICOS DE MIS EMPLEADOS" key="1">
            <g-master :endpoint="vMasterViaticosEmpleados.endpoint"
                      :tableSetup="vMasterViaticosEmpleados.tableSetup"
                      :modalFieldsSetup="vMasterViaticosEmpleados.modalFieldsSetup"
                      :parentData="filtroMisEmpleados"
                      ref="masterComponentJefe"
                      @action="vMasterActionJefe"
                      :actions="false"
            >
              <div slot="kmRender" slot-scope="{text}" style="text-align: right;">
                {{parseInt(text) / 1000}} KM
              </div>
              <span slot="stateRender" slot-scope="{text}">

            <a-tag :color="getColorState(text)"> {{text}} </a-tag>
          </span>
            </g-master>
          </a-tab-pane>
        </a-tabs>
        <!--
            @fieldsChange="fieldsChange"
         -->
      </a-tab-pane>
      <a-tab-pane tab="VEHICULOS / MOTOCICLETAS" key="2" v-if="userHasVehicle || isRolViaticos">
        <g-master name="vehimaster"
                  :endpoint="vehiMaster.endpoint"
                  :tableSetup="vehiMaster.tableSetup"
                  :modalFieldsSetup="vehiMaster.modalFieldsSetup"
                  :beforeSend="vehiMaster.beforeSend"
                  :actions="vehiMaster.actions"
                  @action="vehiMasterAction"
                  :useMultipart="true">
          <template slot="masterModal" slot-scope="{record}">
            <a-row :gutter="[16,16]">
              <a-col v-if="isRolViaticos">
                <g-lookup label="Persona"
                          :formItemConfig="fiOptions"
                          endpoint="personas"
                          :decorator="['id_person', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                          ref="personDropdown">
                </g-lookup>
              </a-col>
              <a-col v-if="isRolViaticos">
                <g-dropdown label="T. Vehiculo"
                            endpoint="hierarchy_lookup"
                            :decorator="['id_h_tipo_vehiculo', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                            :formItemConfig="fiOptions"
                            :params="vehiMaster.tVehiParams"></g-dropdown>
              </a-col>
              <a-col v-if="isRolViaticos">
                <a-form-item label="Placa" v-bind="fiOptions">
                  <a-input
                    v-decorator="['placa', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-if="isRolViaticos">
                <a-form-item label="F. Vencimiento Soat" v-bind="fiOptions">
                  <a-date-picker style="width: 100%"
                                 v-decorator="['soat_due_date']"/>
                </a-form-item>
              </a-col>
              <a-col v-if="isRolViaticos">
                <a-form-item label="F. Vencimiento Seguro" v-bind="fiOptions">
                  <a-date-picker style="width: 100%"
                                 v-decorator="['insurance_due_date']"/>
                </a-form-item>
              </a-col>
              <a-col v-if="isRolViaticos">
                <a-form-item label="F. Vencimiento Técnico Mecánica" v-bind="fiOptions">
                  <a-date-picker style="width: 100%"
                                 v-decorator="['technical_review_due_date']"/>
                </a-form-item>
              </a-col>
              <a-col :md="{span: 8}" :xs="{span: 24}">
                <a-upload
                  name="soat_file"
                  :before-upload="file => beforeUpload(file, 'vehiMaster', 'soat_file')"
                  :remove="file => removeFile(file, 'vehiMaster', 'soat_file')"
                  :fileList="vehiMaster.uploads.soat_file ? [vehiMaster.uploads.soat_file]: []">
                  <a-button style="width: 100%">Seleccionar SOAT</a-button>
                </a-upload>
              </a-col>
              <a-col :md="{span: 8}" :xs="{span: 24}">
                <a-upload
                  name="insurance_file"
                  :before-upload="file => beforeUpload(file, 'vehiMaster', 'insurance_file')"
                  :remove="file => removeFile(file, 'vehiMaster', 'insurance_file')"
                  :fileList="vehiMaster.uploads.insurance_file ? [vehiMaster.uploads.insurance_file]: []">
                  <a-button style="width: 100%">Seleccionar Seguro</a-button>
                </a-upload>
              </a-col>
              <a-col :md="{span: 8}" :xs="{span: 24}">
                <a-upload
                  name="property_card_file"
                  :before-upload="file => beforeUpload(file, 'vehiMaster', 'property_card_file')"
                  :remove="file => removeFile(file, 'vehiMaster', 'property_card_file')"
                  :fileList="vehiMaster.uploads.property_card_file ? [vehiMaster.uploads.property_card_file]: []">
                  <a-button style="width: 100%">Sel. T. de Propiedad</a-button>
                </a-upload>
              </a-col>
              <a-col :md="{span: 8}" :xs="{span: 24}">
                <a-upload
                  name="driver_lic_file"
                  :before-upload="file => beforeUpload(file, 'vehiMaster', 'driver_lic_file')"
                  :remove="file => removeFile(file, 'vehiMaster', 'driver_lic_file')"
                  :fileList="vehiMaster.uploads.driver_lic_file ? [vehiMaster.uploads.driver_lic_file]: []">
                  <a-button style="width: 100%">Sel. Lic. Conducción</a-button>
                </a-upload>
              </a-col>
              <a-col :md="{span: 8}" :xs="{span: 24}">
                <a-upload
                  name="technical_review_file"
                  :before-upload="file => beforeUpload(file, 'vehiMaster', 'technical_review_file')"
                  :remove="file => removeFile(file, 'vehiMaster', 'technical_review_file')"
                  :fileList="vehiMaster.uploads.technical_review_file ? [vehiMaster.uploads.technical_review_file]: []">
                  <a-button style="width: 100%">Sel. Técnico Mecánica</a-button>
                </a-upload>
              </a-col>
            </a-row>
          </template>
        </g-master>
      </a-tab-pane>
      <a-tab-pane v-if="this.$userIsInrol('Gerente')" tab="ACEPTACIÓN DE VIÁTICOS Y KM" key="3">
        <g-master :endpoint="viaticosGerente.endpoint"
                  :tableSetup="viaticosGerente.tableSetup"
                  :actions="viaticosGerente.actions"
                  :parentData="parentDataGerente"
                  ref="masterAprobacionRechazoGerente"
                  @action="masterActionViaticosGerente"
        >
        </g-master>
        <a-tabs default-active-key="1">
          <a-tab-pane tab="INFORMACIÓN DETALLADA" key="1">
            <g-master v-if="viaticoSeleccionado"
                      :endpoint="viaticosGerenteDetallado.endpoint"
                      :tableSetup="viaticosGerenteDetallado.tableSetup"
                      :modalFieldsSetup="viaticosGerenteDetallado.modalFieldsSetup"
                      :actions="false"
                      :parentData="parentDataGerenteDetallado"
                      @action="masterActionViaticosGerenteDetallado"
            >
            </g-master>
            <span v-else>Seleccione un viático para ver más.</span>
          </a-tab-pane>
        </a-tabs>
      </a-tab-pane>
    </a-tabs>
    <a-modal :title="modalRechazoAceptacionGerente.accion"
             :visible="modalRechazoAceptacionGerente.visible"
             @ok="confirmarAprobacionesGerente"
             :confirmLoading="modalRechazoAceptacionGerente.loading"
             @cancel="cancelarAprobacionesGerente"
             style="top: 20px;">
      <strong>Empleado:</strong> {{modalRechazoAceptacionGerente.infoData.idemp}}&nbsp;{{modalRechazoAceptacionGerente.infoData.id_emp_name}}
      <br>
      <strong>Cargo:</strong> {{modalRechazoAceptacionGerente.infoData.cargo}}
      <br>
      <strong>Viáticos:</strong> {{modalRechazoAceptacionGerente.infoData.cantidad_viatico}}
      <br>
      <strong>Kilometraje:</strong> {{modalRechazoAceptacionGerente.infoData.cantidad_km}}
      <br>
      <br>
      <span>¿Está seguro que desea <strong>{{modalRechazoAceptacionGerente.accion}}</strong>?</span>
      <br>
      <a-input v-if="modalRechazoAceptacionGerente.accion === 'Rechazar aprobaciones'" v-model="formularioRechazo.texto"
               type="textarea"/>
      <br>
      <a-alert
        message="Este proceso es complejo de reversar, si comete un error, por favor contactese inmediatamente con un administrador."
        type="info" show-icon/>
    </a-modal>

    <a-modal :title="confirmarModal.accion"
             :visible="confirmarModal.visible"
             @ok="confirmEstado"
             :confirmLoading="confirmarModal.loading"
             @cancel="cancelConfirmEstado"
             style="top: 20px;">
      <span>¿Está seguro que desea {{confirmarModal.accion}} el viatico?</span>
      <a-input v-if="confirmarModal.accion === 'Rechazar'" v-model="formularioRechazo.texto" type="textarea"/>
      <a-alert type="error" :message="confirmarModal.mensajeError" v-if="confirmarModal.error"/>
    </a-modal>

    <a-modal :title="modalInfoRechazo.accion"
             :visible="modalInfoRechazo.visible"
             @ok="modalInfoRechazo.visible = false"
             :cancel-button-props="{style: { display: 'none' } }"
             @cancel="modalInfoRechazo.visible = false"
             style="top: 20px;">
      <span>{{modalInfoRechazo.motivo}}</span>
    </a-modal>
  </div>
</template>
<script>
  import HttpUtil from '@/util/HttpUtil'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'

  export default {
    data () {
      return {
        formularioRechazo: {
          texto: ''
        },
        modalInfoRechazo: {
          accion: 'Motivo de rechazo',
          visible: false,
          motivo: ''
        },
        modalRechazoAceptacionGerente: {
          accion: null,
          visible: false,
          loading: false,
          infoData: {}
        },
        tablaARefrescar: null,
        eskilometrajeTransporte: false,
        esViatico: false,
        tipoViaticoSeleccionado: 'simple_expenses',
        tipoVisitaSeleccionado: null,
        fiOptions: {
          'label-col': {span: 10},
          'wrapper-col': {span: 14},
          'has-feedback': true
        },
        vMaster: {
          actions: [
            {
              name: 'masterCreate',
              text: 'Crear',
              permisos: [],
              props: {icon: 'plus', type: 'button'}
            },
            {
              name: 'liquidarMasivamente',
              text: 'Liquidar masivamente',
              permisos: [],
              props: {icon: 'filter', type: 'primary'},
              fnVisible: (record) => {
                return this.$userIsInrol('viaticos')
              }
            }
          ],
          endpoint: 'viaticos',
          tableSetup: {
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: '#', dataIndex: 'id', sorter: true},
              {title: 'Cod. Empleado', dataIndex: 'id_emp', sorter: true},
              {title: 'Empleado', dataIndex: 'id_emp_name', sorter: true},
              {title: 'Fecha', dataIndex: 'start_date', sorter: true},

              {title: 'H. Salida', dataIndex: 'start_time', sorter: true},
              {title: 'H. Regreso', dataIndex: 'end_time', sorter: true},
              {title: 'Tipo de operación', dataIndex: 'type_operation_desc', sorter: true},

              {title: 'Viaticos Sencillos', dataIndex: 'simple_expenses_desc', sorter: true},
              {title: 'Viaticos Sencillos Pernoctado', dataIndex: 'overnight_expenses_desc', sorter: true},
              {title: 'V. Reemplazo Sencillos', dataIndex: 'replacement_simple_expens_desc', sorter: true},
              {title: 'V. Reemplazo Pernoctado', dataIndex: 'replacement_overnight_exp_desc', sorter: true},
              {title: 'Transporte', dataIndex: 'type_travel_desc', sorter: true},

              {title: 'Origen', dataIndex: 'loc_origin', sorter: true},
              {title: 'Destino', dataIndex: 'loc_destination', sorter: true},
              {
                title: 'Valor del Transporte',
                dataIndex: 'travel_expenses',
                sorter: true,
                scopedSlots: {customRender: 'moneyRender'}
              },
              {title: 'Vehiculo', dataIndex: 'vehiculo', sorter: true},
              {
                title: 'Kilometros Recorridos',
                dataIndex: 'distance',
                sorter: true,
                scopedSlots: {customRender: 'kmRender'}
              },

              {title: 'Visita Bocatoma', dataIndex: 'extra_distance_1_desc', sorter: true},
              {title: 'Vista Planta', dataIndex: 'extra_distance_2_desc', sorter: true},
              {
                title: 'Estado',
                dataIndex: 'state_desc',
                sorter: true,
                scopedSlots: {customRender: 'stateRender'},
                fixed: 'right'
              }
            ],
            actions: {
              width: 150,
              actions: [
                {
                  name: 'masterEdit',
                  text: 'Editar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'edit'},
                  fnVisible: (record) => {
                    return record.state_desc === 'PENDIENTE'
                  }
                },
                {
                  name: 'masterDelete',
                  text: 'Eliminar',
                  permisos: [],
                  props: {size: 'small', icon: 'delete', type: 'link'},
                  fnVisible: (record) => {
                    return record.state_desc === 'PENDIENTE'
                  }
                },
                {
                  name: 'download',
                  text: 'Adjunto',
                  props: {size: 'small', icon: 'download', type: 'link'},
                  fnLoading: (record) => {
                    return this.loadingBtns[record.id] === record.id
                  },
                  fnVisible: (record) => {
                    return record.attachment
                  }
                }, {
                  name: 'aprobar',
                  text: 'Aprobar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'check', style: 'color:green;'},
                  fnVisible: (record) => {
                    return this.hasPermissions(record) && !this.$userIsInrol('ViaticosJefe')
                  }
                },
                {
                  name: 'rechazar',
                  text: 'Rechazar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'close', style: 'color:red'},
                  fnVisible: (record) => {
                    return this.hasPermissions(record) && !this.$userIsInrol('ViaticosJefe')
                  }
                },
                {
                  name: 'liquidada',
                  text: 'Liquidar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'check', style: 'color:blue'},
                  fnVisible: (record) => {
                    return (this.$userIsInrol('Management') || this.$userIsInrol('viaticos')) && (record.state_desc === 'APROBADA' || record.state_desc === 'CONFIRMADA') && !this.$userIsInrol('ViaticosJefe')
                  }
                },
                {
                  name: 'motivoRechazo',
                  text: 'Motivo rechazo',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'warning', style: 'color:brown'},
                  fnVisible: (record) => {
                    return !this.$isEmpty(record.observation_travel)
                  }
                }
              ]
            },
            customSlots: ['estadoRenderer', 'kmRender', 'stateRender']
          },
          modalFieldsSetup: [
            {name: 'id_emp'},
            {name: 'start_date', type: 'date'},
            {name: 'id_loc_origin'},
            {name: 'id_loc_destination'},
            {name: 'start_time', type: 'time'},
            {name: 'end_time', type: 'time'},
            {name: 'simple_expenses'},
            {name: 'overnight_expenses'},
            {name: 'replacement_simple_expenses'},
            {name: 'replacement_overnight_expenses'},
            {name: 'id_person_vehicle'},
            {name: 'type_travel'},
            {name: 'travel_expenses'},
            {name: 'extra_distance_1'},
            {name: 'extra_distance_2'},
            {name: 'type_operation'}
          ],
          uploads: {
            attachment_file: null
          },
          beforeSend: (data) => {
            switch (this.tipoViaticoSeleccionado) {
              case 'simple_expenses':
                data.simple_expenses = true
                data.overnight_expenses = false
                data.replacement_simple_expenses = false
                data.replacement_overnight_expenses = false
                break
              case 'overnight_expenses':
                data.overnight_expenses = true
                data.simple_expenses = false
                data.replacement_simple_expenses = false
                data.replacement_overnight_expenses = false
                break
              case 'replacement_simple_expenses':
                data.replacement_simple_expenses = true
                data.overnight_expenses = false
                data.replacement_overnight_expenses = false
                data.simple_expenses = false
                break
              case 'replacement_overnight_expenses':
                data.replacement_overnight_expenses = true
                data.overnight_expenses = false
                data.replacement_simple_expenses = false
                data.simple_expenses = false
                break
            }

            switch (this.tipoVisitaSeleccionado) {
              case 'extra_distance_1':
                data.extra_distance_1 = true
                data.extra_distance_2 = false
                break
              case 'extra_distance_2':
                data.extra_distance_2 = true
                data.extra_distance_1 = false
                break
            }
            return {...data, ...this.vMaster.uploads}
          },
          empleadoSeleccionado: {}
        },
        vMasterViaticosEmpleados: {
          endpoint: 'viaticos',
          tableSetup: {
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: '#', dataIndex: 'id', sorter: true},
              {title: 'Cod. Empleado', dataIndex: 'id_emp', sorter: true},
              {title: 'Empleado', dataIndex: 'id_emp_name', sorter: true},
              {title: 'Fecha', dataIndex: 'start_date', sorter: true},

              {title: 'H. Salida', dataIndex: 'start_time', sorter: true},
              {title: 'H. Regreso', dataIndex: 'end_time', sorter: true},
              {title: 'Tipo de operación', dataIndex: 'type_operation_desc', sorter: true},

              {title: 'Viaticos Sencillos', dataIndex: 'simple_expenses_desc', sorter: true},
              {title: 'Viaticos Sencillos Pernoctado', dataIndex: 'overnight_expenses_desc', sorter: true},
              {title: 'V. Reemplazo Sencillos', dataIndex: 'replacement_simple_expens_desc', sorter: true},
              {title: 'V. Reemplazo Pernoctado', dataIndex: 'replacement_overnight_exp_desc', sorter: true},
              {title: 'Transporte', dataIndex: 'type_travel_desc', sorter: true},

              {title: 'Origen', dataIndex: 'loc_origin', sorter: true},
              {title: 'Destino', dataIndex: 'loc_destination', sorter: true},
              {
                title: 'Valor del Transporte',
                dataIndex: 'travel_expenses',
                sorter: true,
                scopedSlots: {customRender: 'moneyRender'}
              },
              {title: 'Vehiculo', dataIndex: 'vehiculo', sorter: true},
              {
                title: 'Kilometros Recorridos',
                dataIndex: 'distance',
                sorter: true,
                scopedSlots: {customRender: 'kmRender'}
              },

              {title: 'Visita Bocatoma', dataIndex: 'extra_distance_1_desc', sorter: true},
              {title: 'Vista Planta', dataIndex: 'extra_distance_2_desc', sorter: true},
              {
                title: 'Estado',
                dataIndex: 'state_desc',
                sorter: true,
                scopedSlots: {customRender: 'stateRender'},
                fixed: 'right'
              }
            ],
            actions: {
              width: 150,
              actions: [
                {
                  name: 'aprobar',
                  text: 'Aprobar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'check', style: 'color:green;'},
                  fnVisible: (record) => {
                    return record.state_desc === 'PENDIENTE'
                  }
                },
                {
                  name: 'rechazar',
                  text: 'Rechazar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'close', style: 'color:red'},
                  fnVisible: (record) => {
                    return record.state_desc === 'PENDIENTE'
                  }
                },
                {
                  name: 'download',
                  text: 'Adjunto',
                  props: {size: 'small', icon: 'download', type: 'link'},
                  fnLoading: (record) => {
                    return this.loadingBtns[record.id] === record.id
                  },
                  fnVisible: (record) => {
                    return record.attachment
                  }
                },
                {
                  name: 'motivoRechazo',
                  text: 'Motivo rechazo',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'warning', style: 'color:brown'},
                  fnVisible: (record) => {
                    return !this.$isEmpty(record.observation_travel)
                  }
                }
              ]
            },
            customSlots: ['estadoRenderer', 'kmRender', 'stateRender']
          }
        },
        vehiMaster: {
          endpoint: 'person_vehicle',
          tableSetup: {
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: '#', dataIndex: 'id', sorter: true},
              {title: 'T. Vehiculo', dataIndex: 'h_tipo_vehiculo', sorter: true},
              {title: 'Placa', dataIndex: 'placa', sorter: true},
              {title: 'Id Persona', dataIndex: 'id_person', sorter: true},
              {title: 'Nombre Persona', dataIndex: 'id_person_name', sorter: true},
              {title: 'F. Vencimiento Soat', dataIndex: 'soat_due_date', sorter: true},
              {title: 'F. vencimiento Seguro', dataIndex: 'insurance_due_date', sorter: true},
              {title: 'F. V. Técnico Mecánica', dataIndex: 'technical_review_due_date', sorter: true}
            ],
            actions: {
              width: 150,
              actions: [
                {
                  name: 'masterEdit',
                  text: 'Editar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'edit'}
                },
                {
                  name: 'masterDelete',
                  text: 'Eliminar',
                  permisos: [],
                  props: {size: 'small', icon: 'delete', type: 'link'},
                  fnVisible: () => {
                    return this.isRolViaticos
                  }
                },
                {
                  name: 'soat',
                  text: 'Soat',
                  props: {size: 'small', icon: 'download', type: 'link'},
                  fnLoading: (record) => {
                    return this.loadingVehiBtns[record.id] === record.id
                  },
                  fnVisible: (record) => {
                    return record.soat_file_path
                  }
                },
                {
                  name: 'seguro',
                  text: 'Seguro',
                  props: {size: 'small', icon: 'download', type: 'link'},
                  fnLoading: (record) => {
                    return this.loadingVehiBtns[record.id] === record.id
                  },
                  fnVisible: (record) => {
                    return record.insurance_file_path
                  }
                },
                {
                  name: 'tProp',
                  text: 'T. Prop.',
                  props: {size: 'small', icon: 'download', type: 'link'},
                  fnLoading: (record) => {
                    return this.loadingVehiBtns[record.id] === record.id
                  },
                  fnVisible: (record) => {
                    return record.property_card_file_path
                  }
                },
                {
                  name: 'lic',
                  text: 'Lic. Conducción',
                  props: {size: 'small', icon: 'download', type: 'link'},
                  fnLoading: (record) => {
                    return this.loadingVehiBtns[record.id] === record.id
                  },
                  fnVisible: (record) => {
                    return record.driver_lic_file_path
                  }
                },
                {
                  name: 'tec',
                  text: 'Técnico Mecánica',
                  props: {size: 'small', icon: 'download', type: 'link'},
                  fnLoading: (record) => {
                    return this.loadingVehiBtns[record.id] === record.id
                  },
                  fnVisible: (record) => {
                    return record.technical_review_file_path
                  }
                }
              ]
            }
          },
          actions: [
            {
              name: 'masterCreate',
              text: 'Crear',
              permisos: [],
              props: {icon: 'plus', type: 'button'},
              fnVisible: () => {
                return this.isRolViaticos
              }
            }
          ],
          modalFieldsSetup: [
            {name: 'placa'},
            {name: 'id_person'},
            {name: 'id_h_tipo_vehiculo'},
            {name: 'insurance_due_date', type: 'date'},
            {name: 'soat_due_date', type: 'date'},
            {name: 'technical_review_due_date', type: 'date'}
          ],
          uploads: {
            soat_file: null,
            insurance_file: null,
            property_card_file: null,
            driver_lic_file: null,
            technical_review_file: null
          },
          beforeSend: (data) => {
            return {...data, ...this.vehiMaster.uploads}
          },
          tVehiParams: {
            h_lookup_type: 'TIPO_VEHICULO'
          }
        },
        viaticosGerente: {
          actions: false,
          endpoint: 'viaticos',
          tableSetup: {
            allowSelect: true,
            selectedRows: [],
            tableConfig: {
              rowKey: 'idemp'
            },
            columns: [
              {title: 'Cédula', dataIndex: 'idemp', sorter: true},
              {title: 'Nombre', dataIndex: 'id_emp_name', sorter: true},
              {title: 'Cargo', dataIndex: 'cargo', sorter: true},
              {title: 'Cantidad de viáticos', dataIndex: 'cantidad_viatico', sorter: true},
              {title: 'Cantidad de kilómetros', dataIndex: 'cantidad_km', sorter: true}
            ],
            actions: {
              width: 150,
              actions: [
                {
                  name: 'confirmarAprobaciones',
                  text: 'Confirmar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'check', style: {color: 'green'}}
                },
                {
                  name: 'rechazarAprobaciones',
                  text: 'Rechazar',
                  permisos: [],
                  props: {size: 'small', icon: 'close', type: 'link', style: {color: 'red'}}
                }
              ]
            }
          }
        },
        viaticosGerenteDetallado: {
          actions: false,
          endpoint: 'viaticos',
          tableSetup: {
            tableConfig: {
              rowKey: 'idemp'
            },
            columns: [
              {title: '#', dataIndex: 'id', sorter: true},
              {title: 'Cod. Empleado', dataIndex: 'id_emp', sorter: true},
              {title: 'Empleado', dataIndex: 'id_emp_name', sorter: true},
              {title: 'Fecha', dataIndex: 'start_date', sorter: true},

              {title: 'H. Salida', dataIndex: 'start_time', sorter: true},
              {title: 'H. Regreso', dataIndex: 'end_time', sorter: true},
              {title: 'Tipo de operación', dataIndex: 'type_operation_desc', sorter: true},

              {title: 'Viaticos Sencillos', dataIndex: 'simple_expenses_desc', sorter: true},
              {title: 'Viaticos Sencillos Pernoctado', dataIndex: 'overnight_expenses_desc', sorter: true},
              {title: 'V. Reemplazo Sencillos', dataIndex: 'replacement_simple_expens_desc', sorter: true},
              {title: 'V. Reemplazo Pernoctado', dataIndex: 'replacement_overnight_exp_desc', sorter: true},
              {title: 'Transporte', dataIndex: 'type_travel_desc', sorter: true},

              {title: 'Origen', dataIndex: 'loc_origin', sorter: true},
              {title: 'Destino', dataIndex: 'loc_destination', sorter: true},
              {
                title: 'Valor del Transporte',
                dataIndex: 'travel_expenses',
                sorter: true,
                scopedSlots: {customRender: 'moneyRender'}
              },
              {title: 'Vehiculo', dataIndex: 'vehiculo', sorter: true},
              {
                title: 'Kilometros Recorridos',
                dataIndex: 'distance',
                sorter: true,
                scopedSlots: {customRender: 'kmRender'}
              },

              {title: 'Visita Bocatoma', dataIndex: 'extra_distance_1_desc', sorter: true},
              {title: 'Vista Planta', dataIndex: 'extra_distance_2_desc', sorter: true},
              {
                title: 'Estado',
                dataIndex: 'state_desc',
                sorter: true,
                scopedSlots: {customRender: 'stateRender'},
                fixed: 'right'
              }
            ],
            actions: {
              actions: [{
                name: 'download',
                text: 'Adjunto',
                props: {size: 'small', icon: 'download', type: 'link'},
                fnLoading: (record) => {
                  return this.loadingBtns[record.id] === record.id
                },
                fnVisible: (record) => {
                  return record.attachment
                }
              }]
            }
          }
        },
        loadingVehiBtns: {},
        loadingBtns: {},
        confirmarModal: {
          accion: '',
          visible: false,
          loading: false,
          mensajeError: '',
          error: false
        }
      }
    },
    mounted () {
      this.httpClient = new HttpUtil()
    },
    methods: {
      masterActionViaticosGerenteDetallado (action) {
        switch (action.action) {
          case 'download':
            this.downloadAdjunto(action)
            break
        }
      },
      confirmarAprobacionesGerente () {
        if (this.modalRechazoAceptacionGerente.accion === 'Rechazar aprobaciones' && this.$isEmpty((this.formularioRechazo.texto).replace(/ /g, ''))) {
          Mensajes.error('Error', 'Se requiere un motivo del rechazo')
        } else {
          this.modalRechazoAceptacionGerente.loading = true
          this.httpClient.getInstance().post('viaticos_/confirmar_rechazar_masivo', {
            ...this.modalRechazoAceptacionGerente,
            observacion: this.formularioRechazo.texto
          }).then((response) => {
            this.$refs.masterAprobacionRechazoGerente.$refs.datatable.loadData()
            Mensajes.success('Correcto', 'Operación realizada correctamente')
          }).catch((error) => {
            Mensajes.error('Error', error)
          }).then(() => {
            this.modalRechazoAceptacionGerente.loading = false
            this.modalRechazoAceptacionGerente.visible = false
          })
        }
      },
      cancelarAprobacionesGerente () {
        this.modalRechazoAceptacionGerente.visible = false
        this.modalRechazoAceptacionGerente.accion = null
      },
      masterActionViaticosGerente (actions) {
        switch (actions.action) {
          case 'confirmarAprobaciones':
            this.modalRechazoAceptacionGerente.infoData = actions.record
            this.modalRechazoAceptacionGerente.accion = 'Confirmar aprobaciones'
            this.modalRechazoAceptacionGerente.visible = true
            break
          case 'rechazarAprobaciones':
            this.modalRechazoAceptacionGerente.infoData = actions.record
            this.modalRechazoAceptacionGerente.accion = 'Rechazar aprobaciones'
            this.modalRechazoAceptacionGerente.visible = true
            this.formularioRechazo.texto = ''
            break
        }
      },
      changeTipoOperacion (action) {
        if (action.target.value) {
          this.eskilometrajeTransporte = true
          this.$refs.masterComponent.modal.form.setFieldsValue({
            type_travel: false
          })
          this.tipoViaticoSeleccionado = null
          this.esViatico = false
        } else {
          this.esViatico = true
          this.tipoViaticoSeleccionado = 'simple_expenses'
          this.eskilometrajeTransporte = false
          this.$refs.masterComponent.modal.form.setFieldsValue({
            type_travel: null
          })
        }
      },
      vMasterActionJefe (action) {
        switch (action.action) {
          case 'download':
            this.downloadAdjunto(action)
            break
          case 'aprobar':
            this.confirmarModal.id = action.record.id
            this.confirmarModal.accion = 'Aprobar'
            this.confirmarModal.visible = true
            this.confirmarModal.error = false
            this.confirmarModal.loading = false
            this.tablaARefrescar = 'vMasterJefe'
            break
          case 'rechazar':
            this.confirmarModal.id = action.record.id
            this.confirmarModal.accion = 'Rechazar'
            this.confirmarModal.visible = true
            this.confirmarModal.error = false
            this.confirmarModal.loading = false
            this.tablaARefrescar = 'vMasterJefe'
            this.formularioRechazo.texto = ''
            break
          case 'motivoRechazo':
            this.modalInfoRechazo.visible = true
            this.modalInfoRechazo.motivo = action.record.observation_travel
            break
        }
      },
      vMasterAction (action) {
        if (action.action === 'masterCreate' || action.action === 'masterEdit') {
          this.vMaster.uploads.attachment_file = null
        }
        switch (action.action) {
          case 'download':
            this.downloadAdjunto(action)
            break
          case 'masterCreate':
            this.esViatico = false
            this.eskilometrajeTransporte = false
            this.tipoVisitaSeleccionado = null
            this.tipoViaticoSeleccionado = null
            break
          case 'masterEdit':
            this.tipoVisitaSeleccionado = null
            this.tipoViaticoSeleccionado = null
            if (this.isRolViaticos) {
              this.$refs.empDropDown && this.$refs.empDropDown.handleSearch(action.record.id_emp)
              this.vMaster.empleadoSeleccionado = {
                id_person: action.record.id_person,
                te_kilometraje: action.record.te_kilometraje
              }
            }
            if (action.record.overnight_expenses) {
              this.tipoViaticoSeleccionado = 'overnight_expenses'
            } else if (action.record.replacement_overnight_expenses) {
              this.tipoViaticoSeleccionado = 'replacement_overnight_expenses'
            } else if (action.record.replacement_simple_expenses) {
              this.tipoViaticoSeleccionado = 'replacement_simple_expenses'
            } else if (action.record.simple_expenses) {
              this.tipoViaticoSeleccionado = 'simple_expenses'
            }

            if (action.record.extra_distance_1) {
              this.tipoVisitaSeleccionado = 'extra_distance_1'
            } else if (action.record.extra_distance_2) {
              this.tipoVisitaSeleccionado = 'extra_distance_2'
            }

            if (action.record.type_operation) {
              this.eskilometrajeTransporte = true
              this.esViatico = false
            } else {
              this.esViatico = true
              this.eskilometrajeTransporte = false
            }
            break
          case 'aprobar':
            this.confirmarModal.id = action.record.id
            this.confirmarModal.accion = 'Aprobar'
            this.confirmarModal.visible = true
            this.confirmarModal.error = false
            this.confirmarModal.loading = false
            this.tablaARefrescar = 'vMaster'
            break
          case 'rechazar':
            this.confirmarModal.id = action.record.id
            this.confirmarModal.accion = 'Rechazar'
            this.confirmarModal.visible = true
            this.confirmarModal.error = false
            this.confirmarModal.loading = false
            this.formularioRechazo.texto = ''
            this.tablaARefrescar = 'vMaster'
            break
          case 'liquidada':
            this.confirmarModal.id = action.record.id
            this.confirmarModal.accion = 'Liquidar'
            this.confirmarModal.visible = true
            this.confirmarModal.error = false
            this.confirmarModal.loading = false
            this.tablaARefrescar = 'vMaster'
            break
          case 'motivoRechazo':
            this.modalInfoRechazo.visible = true
            this.modalInfoRechazo.motivo = action.record.observation_travel
            this.tablaARefrescar = 'vMaster'
            break
          case 'liquidarMasivamente':
            this.confirmarModal.accion = 'Liquidar masivamente'
            this.confirmarModal.visible = true
            this.confirmarModal.error = false
            this.confirmarModal.loading = false
            this.tablaARefrescar = 'vMaster'
            break
        }
      },
      vehiMasterAction (action) {
        if (action.action === 'masterCreate' || action.action === 'masterEdit') {
          this.vehiMaster.uploads.soat_file = null
          this.vehiMaster.uploads.insurance_file = null
          this.vehiMaster.uploads.property_card_file = null
        }
        switch (action.action) {
          case 'soat':
          case 'seguro':
          case 'tProp':
          case 'lic':
          case 'tec':
            this.downloadVehiDoc(action)
            break
          case 'masterEdit':
            if (this.isRolViaticos) {
              this.$refs.personDropdown && this.$refs.personDropdown.handleSearch(action.record.id_person)
            }
            break
        }
      },
      downloadFile (endpoint, data, callback) {
        this.httpClient.getInstance().post(endpoint, data, {responseType: 'arraybuffer'}).then((response) => {
          let fileURL = new Blob([response.data], {type: 'application/octet-stream'})
          fileURL = window.URL.createObjectURL(fileURL)
          let fileLink = document.getElementById('file_link_elm')
          if (fileLink === null) {
            fileLink = document.createElement('a')
            fileLink.setAttribute('id', 'file_link_elm')
            document.body.appendChild(fileLink)
          }

          fileLink.setAttribute('href', fileURL)
          fileLink.setAttribute('download', response.headers['x-nombre-archivo'])
          fileLink.click()
        }).catch(() => {
          Mensajes.error('Error', 'No fue posible descargar el archivo.')
        }).then(callback)
      },
      downloadAdjunto (action) {
        /* La instancia no detecta el cambio en el componente tal vez por ser un slot, se actualiza la referencia */
        this.$nextTick(() => {
          this.loadingBtns[action.record.id] = action.record.id
          this.loadingBtns = Object.assign({}, this.loadingBtns)
        })

        this.downloadFile('viaticos/download', {id: action.record.id}, () => {
          delete this.loadingBtns[action.record.id]
          this.loadingBtns = Object.assign({}, this.loadingBtns)
        })
      },
      downloadVehiDoc (action) {
        /* La instancia no detecta el cambio en el componente tal vez por ser un slot, se actualiza la referencia */
        this.$nextTick(() => {
          this.loadingVehiBtns[action.record.id] = action.record.id
          this.loadingVehiBtns = Object.assign({}, this.loadingVehiBtns)
        })

        this.downloadFile('person_vehicle/download', {
          id: action.record.id,
          doc: action.action
        }, () => {
          delete this.loadingVehiBtns[action.record.id]
          this.loadingVehiBtns = Object.assign({}, this.loadingVehiBtns)
        })
      },
      beforeUpload (file, setup, prop) {
        if (this.validateFile(file)) {
          this[setup].uploads[prop] = file
        }
        return false
      },
      removeFile (file, setup, prop) {
        this[setup].uploads[prop] = null
      },
      validateFile (file) {
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'application/pdf'
        if (!isJpgOrPng) {
          this.$message.error('Solo se pemiten imágenes o documentos pdf')
          return false
        }
        const isLt2M = file.size / 1024 / 1024 < 10
        if (!isLt2M) {
          this.$message.error('El tamaño del archivo no puede ser mayor a 10 Megas.')
          return false
        }
        return true
      },
      confirmEstado () {
        if (this.confirmarModal.accion === 'Rechazar' && this.$isEmpty((this.formularioRechazo.texto).replace(/ /g, ''))) {
          Mensajes.error('Error', 'Se requiere un motivo del rechazo')
        } else {
          if (this.confirmarModal.loading) return
          this.confirmarModal.loading = true
          this.httpClient.getInstance().get('viaticos_/status/' + this.confirmarModal.id,
            {
              params: {status: this.confirmarModal.accion, observacion: this.formularioRechazo.texto}
            }
          ).then((response) => {
            this.confirmarModal.error = false
            this.confirmarModal.loading = false
            this.confirmarModal.visible = false
            if (this.tablaARefrescar === 'vMaster') {
              this.$refs.masterComponent && this.$refs.masterComponent.$refs.datatable.loadData()
            }
            if (this.tablaARefrescar === 'vMasterJefe') {
              this.$refs.masterComponentJefe && this.$refs.masterComponentJefe.$refs.datatable.loadData()
            }
          }).catch((error) => {
            this.confirmarModal.error = true
            this.confirmarModal.mensajeError = error && error.response && error.response.data && error.response.data.message
            this.confirmarModal.loading = false
          })
        }
      },
      cancelConfirmEstado () {
        if (this.confirmarModal.loading) return

        this.confirmarModal.visible = false
        this.confirmarModal.error = false
        this.confirmarModal.accion = ''
      },
      getColorState (text) {
        let color = 'blue'
        if (text === 'RECHAZADA') {
          color = 'red'
        } else if (text === 'APROBADA') {
          color = 'green'
        } else if (text === 'CONFIRMADA') {
          color = 'purple'
        }
        return color
      },
      hasPermissions (record) {
        let status = record.state_desc === 'PENDIENTE'
        if ((!this.$userIsInrol('Management') || !this.$userIsInrol('viaticos')) && status) {
          status = this.$userIsInrol('ViaticosJefe')
        }
        return status
      }
    },
    computed: {
      parentDataGerenteDetallado () {
        return {
          'filtro_gerente_detallada': true,
          'id_emp': this.viaticoSeleccionado.idemp,
          'type_operation_desc': this.viaticoSeleccionado.type_operation_desc
        }
      },
      viaticoSeleccionado () {
        return this.viaticosGerente.tableSetup.selectedRows.length > 0 ? this.viaticosGerente.tableSetup.selectedRows[0] : null
      },
      parentDataGerente () {
        return {filtro_gerente: true}
      },
      isRolViaticos () {
        /* solo este usuario puede crear vehiculos */
        return this.$userIsInrol('viaticos')
      },
      userHasVehicle () {
        return this.isRolViaticos ? true : this.$store.state.userInfo.te_kilometraje === 'S'
      },
      vehicleParams () {
        return {
          id_person: this.vMaster.empleadoSeleccionado.id_person || this.$store.state.userInfo.id_person
        }
      },
      filtroMisEmpleados () {
        return {
          mis_empleados: true
        }
      },
      filtroMisViaticos () {
        return {
          mis_viaticos: true
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Viaticos/Viaticos.vue